import eventListeners from './event-listeners';
import documentInputHandler from '../handlers/document-input-handler';

const inputListener = (element) => {
  eventListeners.add(element, 'input', documentInputHandler);
};

export default inputListener;
